// import pageTypes from "../values/pageTypes";
// import pageTitles from "../values/pageTitles";

// const commonProps = {
//     clickId: null,
// };

const pageLoadConfig = {

};

export default pageLoadConfig;
